module.exports = __webpack_public_path__ + "img/Glenda.ec6a76ef.png";